import React from 'react'
import { AnchorButton, NonIdealState } from '@blueprintjs/core'
import * as sourcemap from 'sourcemapped-stacktrace'
import { isError } from 'ui-lib'


const unknownError = new Error('Unknown error')

const ErrorState = ({ error: maybeError }: { error?: unknown }) => {
  const error = isError(maybeError) ? maybeError : unknownError

  const [mappedError, setMappedError] = React.useState<Error | undefined>(error)

  React.useEffect(() => {
    if (error) {
      sourcemap.mapStackTrace(error && error.stack, (stack) =>
        setMappedError({
          name: error.name,
          message: error.message,
          stack: stack.join('\n') || error.stack,
        }),
      )
    }
  }, [error])

  const createRadarURL = (user: {}, error?: Error)=>{
return "/contact-us"
  }

  return (
    <NonIdealState
      title="Something went wrong"
      icon="error"
      description={error ? error.message : 'Unknown error'}
      action={
        <AnchorButton
          rightIcon={'share'}
          href={createRadarURL({}, mappedError)}
        >
          File an Issue
        </AnchorButton>
      }
    />
  )
}

export default ErrorState
